import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {toggleModal} from '../store/actions/toggleModalActions';
import {editField} from '../store/actions/fieldsActions';
import './FieldModal.scss';

import ButtonSpinner from "./_common/ButtonSpinner";

const selector = state => {
  const {language, disableButtons, users} = state;
  return {
    t: language.translator,
    disableButtons: disableButtons,
    selected: users.selected
  }
};

const FieldModal = props => {
  const {edit, field} = props;
  const {t, disableButtons} = useSelector(selector);
  const dispatch = useDispatch();

  const [fieldName, setFieldName] = useState(field ? field.name : '');
  const [orangeRange, setOrangeRange] = useState(field ? field.orangeRange : -100);
  const [redRange, setRedRange] = useState(field ? field.redRange : -100);

  const closeModal = () => {
    dispatch(toggleModal(false, ''));
  };

  const handleEditFieldClick = () => {
    const fieldData = {
      id: field.id,
      name: fieldName,
      orangeRange,
      redRange
    };

    dispatch(editField(fieldData));

    closeModal();
  };

  return (
    <div
      className='fieldModalBlur'
      onClick={e => {
        if (e.target.className === 'fieldModalBlur') {
          closeModal()
        }
      }}
    >
      <div className='fieldModal'>
        <div className='fieldModalHeader'>
          <div className='fieldModalTitleContainer'>
            <div className='fieldModalTitle'>
              {!edit ? t.gettext('Add New Field') : t.gettext('Edit Field')}
            </div>
          </div>
          <div className='fieldModalCloseButtonHolder'>
                        <span
                          className='material-icons fieldModalCloseButton'
                          onClick={closeModal}
                        >
                            cancel
                        </span>
          </div>
        </div>
        <div className='fieldModalContent'>
          <form className='fieldForm' autoComplete='off'>
            <div className='fieldFormItem'>
              <label className='fieldFormLabel'>
                {t.gettext('Field name')}
              </label>
              <input
                className='fieldFormInput'
                defaultValue={field ? field.name : ''}
                onInput={e => {
                  setFieldName(e.target.value);
                }}
                type='text'
              />
            </div>
            <div className='fieldFormItem'>
              <label className='fieldFormLabel'>
                {t.gettext('Field code')}
              </label>
              <input
                className='fieldFormInput'
                defaultValue={field ? field.fieldCode : ''}
                onInput={e => {
                  setFieldName(e.target.value);
                }}
                type='text'
                disabled
              />
            </div>
            <div className='fieldFormItem'>
              <label className='fieldFormLabel'>
                {t.gettext('Orange Range')}
              </label>
              <input
                className='fieldFormInput'
                defaultValue={field ? field.orangeRange : ''}
                onInput={e => {
                  setOrangeRange(Number(e.target.value));
                }}
                type='number'
                step={0.1}
              />
            </div>
            <div className='fieldFormItem'>
              <label className='fieldFormLabel'>
                {t.gettext('Red Range')}
              </label>
              <input
                className='fieldFormInput'
                defaultValue={field ? field.redRange : ''}
                onInput={e => {
                  setRedRange(Number(e.target.value));
                }}
                type='number'
                step={0.1}
              />
            </div>
            <div className='fieldButtonsHolder'>
              {edit &&
                <button
                  className='fieldAddButton fieldEditButton'
                  onClick={e => {
                    e.preventDefault();
                    handleEditFieldClick();
                  }}
                  disabled={disableButtons}
                >
                  {t.gettext('Save')}
                  {disableButtons && <ButtonSpinner black/>}
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FieldModal;
